import React from "react";

const UnorderedList = ({ customComponent, onClick, isActive, isDisabled }) => {
	const toggleBulletList = () => {
		if (onClick) onClick();
	};

	return (
		<>
			<button
				className={`editor-menu-item${isActive ? " is-active" : ""}`}
				onClick={toggleBulletList}
				title="Unordered List"
				type="button"
				disabled={isDisabled}>
				{customComponent ? customComponent : <i className="fas fa-list-ul" />}
			</button>
		</>
	);
};

export default UnorderedList;
